// Use global React instead of importing
declare const React: any;

import {isAnyFittersSelected} from "@/app/events/store/event-list.store";
import {useSignals} from "@preact/signals-react/runtime";
import EventFilter from "@/app/events/components/EventFilter";
// import {Loader} from "@/components/ui/loader";
import {EventListContainer} from "@/app/events/components/EventListContainer";
import {useSearchParams} from "next/navigation";

const EventFilterText = ()=> {
    useSignals()
    return (<h1 className="text-2xl font-bold mb-6">{isAnyFittersSelected.value ? 'Showing events for' : 'All Events'}</h1>)
}

// const EventListContainerWrapper = ()=>{
//     const params = useSearchParams();
//     const paramsObject = Object.fromEntries(params.entries())


//     return (
       
//     )
// }



export const SharedEventList = () => {
    const params = useSearchParams();
    const paramsObject = Object.fromEntries(params.entries())

    return (
        <div className="relative">

        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
             <div className="flex justify-between pt-20 mb-4">
                <EventFilterText/>
                <EventFilter/>

            </div>
            <EventListContainer params={paramsObject}/> 
        </div>
    </div>
    )
}




export const TestComponent2 = () => {
    return React.createElement('div', null,
        React.createElement('h1', null, 'This is shared component 2')
    );
}

// Wrapper component for vanilla JS environment
export const SharedEventListWrapper = () => {
    return React.createElement(SharedEventList);
}